module.exports = __webpack_public_path__ + "static/media/sungchan-1.jpeg";